<template>
  <div>
    <CruiseDetailRow v-if="cruiseDetail.isRow" />
    <CruiseDetailHp v-else />
  </div>
</template>

<script>
const CruiseDetailHp = () =>
  import("@/components/Cruise/CruiseDetailHp.vue");
const CruiseDetailRow = () =>
  import("@/components/Cruise/CruiseDetailRow.vue");
export default {
  name: "CruiseDetail",
  components: {
    CruiseDetailHp,
    CruiseDetailRow
  },
  activated() {
    const shipCode = this.$router.currentRoute.query.shipCode;
    const sailDate = this.$router.currentRoute.query.sailDate;
    if (shipCode != this.shipCode || sailDate != this.sailDate) {
      window.scrollTo(0, 0);
      this.initPage();
    }

  },
  methods:{
    initPage() {
      this.$store.commit("SET_PAGE_TITLE", "航线详情");
      const shipCode = this.$router.currentRoute.query.shipCode;
      const sailDate = this.$router.currentRoute.query.sailDate;
      const userToken = this.$store.state.user.userToken;
      if (this.shipCode != shipCode || this.sailDate != sailDate) {
        try {
          if (window && window.gio) {
            window.gio("app.set", "ShipCode", shipCode);
            window.gio("app.set", "SailDate", sailDate);
            window.gio("page.set", "CruiseLine", shipCode + sailDate);
            window.gio("page.set", "ShipCode", shipCode);
            window.gio("page.set", "SailDate", sailDate);
            window.gio("track", "CruiseDetail");
            window.gio('track','evt_cruiseDetail ', {'shipCode': shipCode,'sailDate' : sailDate} )
            const hmsr = this.$store.state.page.trackingCode.hmsr || "";
            if (hmsr.length > 0) {
              window.gio("track", "BF01_DetailPages", { hmsr: hmsr });
            }
          }
        } catch (e) {
          console.error(e);
        }
        this.$loading.show();
        return this.$store.dispatch("GET_CRUISE_DETAIL", {
          requestData: {
            shipCode: shipCode,
            sailDate: sailDate,
            username: userToken,
            tagSource: "mobile",
          },
        });
      }
    },
  },
  computed:{
    // 航线详情
    cruiseDetail() {
      return this.$store.state.cruise.cruiseDetail.data;
    },
    shipCode() {
      return this.$store.state.cruise.cruiseDetail.shipCode;
    },
    sailDate() {
      return this.$store.state.cruise.cruiseDetail.sailDate;
    }
  }, 

  watch:{
    cruiseDetail() {
      this.$loading.hide();
    },
  },
}
</script>

<style lang="less" scoped></style>